// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"dc85250a","739":"acdb83e2"}[chunkId] + ".chunk.js";
};